export const enum TEST_IDS {
	PAGE_TITLE = 'search.LandingPage.title',
	HEADER_SEARCH_LINK = 'header.search.landingPageLink',
}
